import { Modal, Button, Spinner } from "flowbite-react";

interface ConfirmationDialogProps {
  title: string;
  body: string;
  onCancel: () => void;
  onConfirm: () => void;
  isLoading?: boolean;
}

function ConfirmationDialog({
  title,
  body,
  onCancel,
  onConfirm,
  isLoading = false,
}: ConfirmationDialogProps) {
  return (
    <Modal show={true} onClose={onCancel}>
      <Modal.Header>{title}</Modal.Header>
      <Modal.Body>
        <p>{body}</p>
      </Modal.Body>
      <Modal.Footer className="flex justify-end">
        <Button color="gray" onClick={onCancel} disabled={isLoading}>
          Cancel
        </Button>
        <Button color="failure" onClick={onConfirm} disabled={isLoading}>
          {isLoading ? (
            <div className="flex items-center">
              <Spinner size="sm" className="mr-2" />
              Processing...
            </div>
          ) : (
            "Confirm"
          )}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default ConfirmationDialog;
